import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { FilterContext } from '../../Context/FilterContext'

const filterUrl = `https://zomatourl.herokuapp.com/filter`

const CuisineFilter = () => {
    const { setRestaurants} = useContext(FilterContext)
    const params = useParams();
    const mealId = params.id;

    const filterCuisine = (e) => {
        fetch(`${filterUrl}/${mealId}?cuisine=${e.target.value}`)
            .then(res => res.json())
            .then(data => {
                setRestaurants(data)
            })
            .catch(err => {
                console.log(err);
            })

    }
    return (
        <div>
            <div className="cuisine mt-4" onChange={filterCuisine}>
            <h6>Cuisine</h6>
                <div className="all">
                    <label htmlFor="all" >
                        <input type="radio" name="cuisine" id="all" className='me-2' value={""} />
                        All
                    </label>
                </div>
                <div className="north-indian">
                    <label htmlFor="north-indian" >
                        <input type="radio" name="cuisine" id="north-indian" className='me-2' value={"1"} />
                        North Indian
                    </label>
                </div>
                <div className="south-indian">
                    <label htmlFor="south-indian" >
                        <input type="radio" name="cuisine" id="south-indian" className='me-2' value={"2"} />
                        South Indian
                    </label>
                </div>
                <div className="chinese">
                    <label htmlFor="chinese" >
                        <input type="radio" name="cuisine" id="chinese" className='me-2' value={"3"} />
                        Chinese
                    </label>
                </div>
                <div className="fast-food">
                    <label htmlFor="fast-food" >
                        <input type="radio" name="cuisine" id="fast-food" className='me-2' value={"4"} />
                        Fast Food
                    </label>
                </div>
                <div className="Street-food">
                    <label htmlFor="Street-food" >
                        <input type="radio" name="cuisine" id="Street-food" className='me-2' value={"5"} />
                        Street Food
                    </label>
                </div>
            </div>
        </div>
    )
}

export default CuisineFilter